export enum MasterarbeitsanmeldungVariables {
  studium = 'studium',
  nameStudent = 'nameStudent',
  matrikelnummer = 'matrikelnummer',
  studienkennzahl = 'studienkennzahl',
  typAntragMasterarbeit_LABEL = 'typAntragMasterarbeit_LABEL',
  hauptbetreuungIntern1_LABEL = 'hauptbetreuungIntern1_LABEL',
  hauptbetreuungIntern2 = 'hauptbetreuungIntern2',
  hauptbetreuungExtern2 = 'hauptbetreuungExtern2',
  mitbetreuung1_LABEL = 'mitbetreuung1_LABEL',
  mitbetreuung2_LABEL = 'mitbetreuung2_LABEL',
  journal = 'journal',
  weitereAutoren = 'weitereAutoren',
  spracheStandard_LABEL = 'spracheStandard_LABEL',
  schwerpunkt_LABEL = 'schwerpunkt_LABEL',
  proposal = 'proposal',
  mitwirkende = 'mitwirkende',
  arbeitstitel = 'arbeitstitel',
  kommentarStudent = 'kommentarStudent',
  typMasterarbeit = 'typMasterarbeit',
  organisation_LABEL = 'organisation_LABEL',
  reviewerNameProgrammbegleitung = 'reviewerNameProgrammbegleitung',
  reviewerNameSts = 'reviewerNameSts',
  reviewerNameSchwerpunktkoordinatoren = 'reviewerNameSchwerpunktkoordinatoren',
  reviewerNameOeleitung = 'reviewerNameOeleitung',
  reviewerNameDekan = 'reviewerNameDekan',
  finaleFreigaben = "finaleFreigaben",

  _bokuFlow_workflowResult = "_bokuFlow_workflowResult",
  _bokuFlow_workflowResultProtocolJSON = '_bokuFlow_workflowResultProtocolJSON',
  originalMasterarbeit = 'originalMasterarbeit',
}

export const MasterarbeitsanmeldungVariablesSearchable = [
  MasterarbeitsanmeldungVariables.nameStudent,
  MasterarbeitsanmeldungVariables.matrikelnummer,
  MasterarbeitsanmeldungVariables.studienkennzahl,
  MasterarbeitsanmeldungVariables.typAntragMasterarbeit_LABEL,
  MasterarbeitsanmeldungVariables.hauptbetreuungIntern1_LABEL,
  MasterarbeitsanmeldungVariables.hauptbetreuungIntern2,
  MasterarbeitsanmeldungVariables.hauptbetreuungExtern2,
  MasterarbeitsanmeldungVariables.mitbetreuung1_LABEL,
  MasterarbeitsanmeldungVariables.mitbetreuung2_LABEL,
  MasterarbeitsanmeldungVariables.journal,
  MasterarbeitsanmeldungVariables.weitereAutoren,
  MasterarbeitsanmeldungVariables.spracheStandard_LABEL,
  MasterarbeitsanmeldungVariables.schwerpunkt_LABEL,
  MasterarbeitsanmeldungVariables.proposal,
  MasterarbeitsanmeldungVariables.mitwirkende,
  MasterarbeitsanmeldungVariables.arbeitstitel,
  MasterarbeitsanmeldungVariables.kommentarStudent,
  MasterarbeitsanmeldungVariables.typMasterarbeit,
];
